"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.declareConsent = declareConsent;
exports.getDeclaration = getDeclaration;
exports.getDeviceData = getDeviceData;
exports.getDeviceFile = getDeviceFile;
exports.getDevices = getDevices;
exports.getHanDevices = getHanDevices;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function getDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/meters"));
  }, 'smartmeter');
}
function getHanDevices() {
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/meters?filterBy=hanEnabledDevices"));
  }, 'smartmeter');
}
function getDeviceData(serialNumber, obises, fromDate, toDate) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/meters/").concat(serialNumber, "/obises/").concat(obises, "?from=").concat(fromDate, "&to=").concat(toDate));
}
function getDeclaration() {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/consent"));
}
function declareConsent(accepted) {
  return _RestHelper.default.put("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/consent"), {
    agreed: accepted
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
function getDeviceFile(serialNumber, obises, fromDate, toDate) {
  return _RestHelper.default.post("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/smartmeter/v0/meters/").concat(serialNumber, "/obises/").concat(obises, "/excel?from=").concat(fromDate, "&to=").concat(toDate), {}, {
    responseType: 'arraybuffer'
  });
}